module.exports = "#result-info span {\n  display: block; }\n"